/* BreezeBoxer product page: gallery, review carousel, option pickers, pack cards, add to cart. */
(function () {
  var SIZE_LABEL = { 'XXXXL': '4XL', 'XXXL': '3XL', 'XXL': '2XL' };
  var SIZE_RANK = { 'S': 1, 'M': 2, 'L': 3, 'XL': 4, 'XXL': 5, '2XL': 5, 'XXXL': 6, '3XL': 6, 'XXXXL': 7, '4XL': 7, 'XXXXXL': 8, '5XL': 8 };
  function init(root) {
    if (!root || root.dataset.bbInit) return;
    root.dataset.bbInit = '1';
    var sid = root.dataset.sid;
    var atcText = root.dataset.atc || 'Add to cart';
    var packIdx = parseInt(root.dataset.packIdx, 10);
    var cartAdd = root.dataset.cartAdd || '/cart/add';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var vEl = document.getElementById('eh-variants-' + sid);
    if (!vEl) return;
    var variants = JSON.parse(vEl.textContent);
    var cc = root.dataset.currency || 'USD';
    var fmt = function (cents) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cc }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } };
    var q = function (s, r) { return (r || root).querySelector(s); };
    var qa = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* size pills: short labels (L, XL, 2XL, 3XL, 4XL) in size order; the real option value is untouched */
    qa('.ehp-sz').forEach(function (b) {
      var v = (b.dataset.value || '').toUpperCase().replace(/\s/g, '');
      if (SIZE_LABEL[v]) b.textContent = SIZE_LABEL[v];
      if (SIZE_RANK[v]) b.style.order = SIZE_RANK[v];
    });

    /* gallery */
    var stage = q('#stage-' + sid);
    var slides = stage ? qa('.ehp-slide', stage) : [], thumbs = qa('.ehp-thumb'), idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== idx; });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === idx); });
      var t = thumbs[idx], box = t && t.parentNode;
      if (box) box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
    qa('.ehp-arrow').forEach(function (b) { b.addEventListener('click', function () { show(idx + +b.dataset.dir); }); });
    if (stage) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) show(idx + (dx < 0 ? 1 : -1));
      }, { passive: true });
      stage.addEventListener('mousedown', function (e) { x0 = e.clientX; });
      stage.addEventListener('mouseup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 60) show(idx + (dx < 0 ? 1 : -1)); });
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });

    /* review carousel under the thumbnails: swaps on its own, pauses on hover and focus */
    var qc = q('#qc-' + sid);
    if (qc) {
      var sl = qa('.bb-qs', qc), ds = qa('.bb-dot', qc), qi = 0, timer = null;
      var go = function (n) {
        qi = (n + sl.length) % sl.length;
        sl.forEach(function (s, k) { s.setAttribute('aria-hidden', k !== qi); });
        ds.forEach(function (d, k) { d.setAttribute('aria-current', k === qi); });
      };
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      var start = function () { if (timer || sl.length < 2 || reduce) return; timer = setInterval(function () { go(qi + 1); }, 5000); };
      ds.forEach(function (d, k) { d.addEventListener('click', function () { go(k); stop(); }); });
      qc.addEventListener('mouseenter', stop); qc.addEventListener('mouseleave', start);
      qc.addEventListener('focusin', stop); qc.addEventListener('focusout', start);
      start();
    }

    /* options, prices, pack cards */
    function selected() { return qa('.ehp-opt').map(function (o) { var b = q('[aria-pressed="true"]', o); return b ? b.dataset.value : null; }); }
    function find(sel) { return variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0]; }
    function saveText(v) { return v.c > v.p ? 'SAVE ' + fmt(v.c - v.p) + ' · ' + Math.round((v.c - v.p) / v.c * 100) + '% OFF' : ''; }
    function render() {
      var sel = selected(), v = find(sel);
      var atc = q('#atc-' + sid), label = q('[data-label]', atc), err = q('#err-' + sid);
      err.hidden = true;
      qa('.ehp-opt').forEach(function (o) { var b = q('[aria-pressed="true"]', o), n = q('.ehp-selname', o); if (b && n) n.textContent = b.dataset.value; });
      if (!v) { atc.disabled = true; label.textContent = 'Unavailable'; return; }
      q('#vid-' + sid).value = v.id;
      q('#price-' + sid).textContent = fmt(v.p);
      var cmp = q('#compare-' + sid), was = q('#was-' + sid), save = q('#save-' + sid), per = q('#per-' + sid);
      if (v.c > v.p) { cmp.textContent = fmt(v.c); was.hidden = false; save.textContent = saveText(v); save.hidden = false; } else { was.hidden = true; save.hidden = true; }
      if (v.u > 1) { per.textContent = fmt(Math.round(v.p / v.u)) + ' per pair'; per.hidden = false; } else { per.hidden = true; }
      atc.disabled = !v.a;
      label.textContent = v.a ? atcText : 'Sold out';
      qa('.ehp-bundle').forEach(function (b) {
        var s2 = sel.slice(); s2[packIdx] = b.dataset.value;
        var bv = find(s2) || v;
        q('[data-price]', b).textContent = fmt(bv.p);
        var w = q('[data-was]', b); w.textContent = bv.c > bv.p ? fmt(bv.c) : ''; w.hidden = !(bv.c > bv.p);
        q('[data-per]', b).textContent = bv.u > 1 ? fmt(Math.round(bv.p / bv.u)) + ' / pair' : '';
        q('[data-save]', b).textContent = saveText(bv);
      });
      var chosen = q('.ehp-bundle[aria-pressed="true"]'), ship = q('#ship-' + sid);
      if (chosen && chosen.dataset.ship) { ship.textContent = chosen.dataset.ship; ship.hidden = false; } else { ship.hidden = true; }
      var sp = q('#stickyp-' + sid); if (sp) sp.textContent = 'From ' + fmt(v.p);
      if (v.m) { var n = slides.findIndex(function (s) { return +s.dataset.mediaId === v.m; }); if (n > -1) show(n); }
    }
    qa('.ehp-opt').forEach(function (o) {
      o.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-value]'); if (!b) return;
        qa('button[data-value]', o).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        render();
      });
    });

    /* add to cart */
    var form = q('#form-' + sid);
    function add(e) {
      if (e) e.preventDefault();
      var atc = q('#atc-' + sid); if (atc.disabled) return;
      atc.disabled = true; q('[data-label]', atc).textContent = 'Adding...';
      var fd = new FormData(form); fd.set('quantity', 1);
      fetch(cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
        .then(function () { window.location.href = cartUrl; })
        .catch(function (err) { var el = q('#err-' + sid); el.textContent = err.message; el.hidden = false; atc.disabled = false; render(); });
    }
    form.addEventListener('submit', add);
    var a2 = q('#atc2-' + sid); if (a2) a2.addEventListener('click', add);
    render();
  }
  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('.ehp[data-sid]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();